import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { COVER_AI_RUN_SIZE } from 'fym-shared/src/music24/coverEditorPlans';
import { TypedMemo } from '../../../common/types';
import { useCoverEditor } from '../../CoverEditorContext';
import { coverEditorMessages } from '../../coverEditorMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The AI pictures of the workspace this month (owner decision D5: a monthly limit by plan): the
 * count, the bar, and the day the count starts again when fewer than one run is left.
 */
const AiMeterComponent: React.FC = () => {
  const intl = useIntl();
  const { quota } = useCoverEditor().data;
  const isFull = quota.limit - quota.used < COVER_AI_RUN_SIZE;
  const share = quota.limit <= 0 ? 1 : Math.min(1, quota.used / quota.limit);
  return (
    <div className={clsx(styles.meterBox, isFull && styles.meterBoxFull)}>
      <div className={styles.meterLine}>
        <span>{intl.formatMessage(coverEditorMessages.aiMeterLabel)}</span>
        <span>{intl.formatMessage(coverEditorMessages.aiMeterValue, { used: quota.used, limit: quota.limit })}</span>
      </div>
      <div
        className={styles.meter}
        role="progressbar"
        aria-valuenow={quota.used}
        aria-valuemin={0}
        aria-valuemax={quota.limit}
        aria-label={intl.formatMessage(coverEditorMessages.aiMeterLabel)}
      >
        <span style={{ width: `${share * 100}%` }} />
      </div>
      {isFull && (
        <span className={styles.hint}>
          {intl.formatMessage(coverEditorMessages.aiMeterFull, {
            date: intl.formatDate(quota.resetsAt, { dateStyle: 'medium' }),
          })}
        </span>
      )}
    </div>
  );
};

export const AiMeter = TypedMemo(AiMeterComponent);
